import React from 'react';
import { NavLink } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { Ripple } from 'primereact/ripple';
import { Badge } from 'primereact/badge';
import { SideBarItem } from './AppMenuTypes';

type AppMenuLinkProps = {
  item: SideBarItem;
  index: number;
  root?: boolean;
  onMenuItemClick: (
    event: React.SyntheticEvent<Element, Event>,
    item: SideBarItem,
    index: number
  ) => void;
};

const AppMenuLink = ({
  item,
  index,
  root,
  onMenuItemClick,
}: AppMenuLinkProps) => {
  const menuitemIconClassName = classNames('layout-menuitem-icon', item.icon);
  const content = (
    <>
      {item.icon && <i className={menuitemIconClassName}></i>}
      {item.iconIMG && (
        <div className="w-3rem flex justify-content-center">
          <img
            className={` ${!item.disabled && 'svgWhite'}`}
            src={item.iconIMG}
            alt={`${item.label} img`}
          />
        </div>
      )}
      <span
        className={`layout-menuitem-text ${
          item.disabled ? 'disabledText' : 'text-white'
        }`}
      >
        {item.label}
      </span>
      {item.badge && (
        <Badge
          value={item.badge}
          style={item.badgeStyle}
          className={classNames(item.badgeClassName, 'p-badge-no-gutter')}
        />
      )}
      {item.items && (
        <i className="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
      )}
      <Ripple />
    </>
  );
  const commonLinkProps = {
    style: item.style,
    className: classNames(item.className, 'p-ripple tooltip', {
      'p-disabled': item.disabled,
      'p-link': !item.to,
    }),
    onClick: (e: React.SyntheticEvent) => onMenuItemClick(e, item, index),
  };

  if (item.url) {
    return (
      <a
        data-pr-tooltip={root && item.label}
        href={item.url}
        rel="noopener noreferrer"
        {...commonLinkProps}
      >
        {content}
      </a>
    );
  } else if (!item.to) {
    return (
      <a
        data-pr-tooltip={root && item.label}
        type="button"
        {...commonLinkProps}
      >
        {content}
      </a>
    );
  }

  return (
    <NavLink
      data-pr-tooltip={root && item.label}
      to={item.to}
      {...commonLinkProps}
      className={({ isActive }) =>
        classNames(
          commonLinkProps.className,
          isActive ? 'router-link-active' : undefined
        )
      }
    >
      {content}
    </NavLink>
  );
};

export default AppMenuLink;
